import { render, staticRenderFns } from "./AddShopQrCode.vue?vue&type=template&id=9af24ac6"
import script from "./AddShopQrCode.vue?vue&type=script&lang=js"
export * from "./AddShopQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports